export default __webpack_public_path__ + "img/999f6c7d5f65fc2ec3effef777a49ab2.svg";